import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { IItem } from 'PDF/components/SWOT/SWOTRow';
import { getColorObjectsStyleByRecord } from 'PDF/helpers/documentStyle';

import { List } from '../List/List';

interface ISWOTItemProps {
  data: IItem;
  isRight: boolean;
}

const colorIndexes = {
  green: [3, 12, 2],
  blue: [3, 5, 2],
  red: [3, 5, 2],
  blueGreen: [6, 0, 2],
  blueRed: [0, 3, 2],
  blueYellow: [0, 5, 35],
};

export const SWOTItem = ({ data, isRight }: ISWOTItemProps) => {
  const [{ leftColor }, { rightColor }, backgroundColor] = getColorObjectsStyleByRecord(colorIndexes, [
    'leftColor',
    'rightColor',
    'backgroundColor',
  ]);

  return (
    <View style={[styles.wrapper, backgroundColor, { marginLeft: isRight ? '15px' : '0px' }]}>
      <View style={styles.headerWrapper} fixed={true}>
        <View style={[styles.iconWrapper, { backgroundColor: isRight ? rightColor : leftColor }]}>
          <Image src={data.iconSrc} style={styles.icon} />
        </View>
        <View style={styles.headerTextWrapper}>
          <Text style={[styles.headerText, { color: isRight ? rightColor : leftColor }]}>{data.title}</Text>
        </View>
      </View>
      <View style={styles.listWrapper}>
        <List steps={data.content} color={{ color: isRight ? rightColor : leftColor }} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    padding: '0 10px 13px 13px',
    width: '255px',
    fontSize: '9px',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '6px',
    marginTop: '10px',
  },
  iconWrapper: {
    width: '35px',
    height: '33px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTextWrapper: {
    display: 'flex',
    justifyContent: 'center',
    height: '24px',
    backgroundColor: '#fff',
    position: 'relative',
    zIndex: '-1',
    marginLeft: '-21px',
    width: '100%',
    alignItems: 'center',
  },
  headerText: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: 9,
  },
  listWrapper: {
    maxWidth: '100%',
  },
  icon: {
    height: '16.88px',
    width: '16.97px',
  },
});
